export default __webpack_public_path__ + "static/media/how-it-works-1.153af317.png";